import React, { useCallback, useState, useEffect } from 'react';
import Masonry from 'react-masonry-css';
import PropTypes from 'prop-types';
import {
  Button, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem,
} from 'reactstrap';
import moment from 'moment';
import classnames from 'classnames';
import ReactTooltip from 'react-tooltip';
import { find } from 'lodash';
import InfiniteScroll from 'react-infinite-scroll-component';
import ReactImageFallback from 'react-image-fallback';
import { calculateDateDiff, getDaysDiff } from '../../../utils/common';
import {
  dateFormats, OFFER_TABS, ERROR_ICON, OFFER_STATUS, NUMERIC_VALUE,
  TIME_ICON_RED, BETA_POST_ENUM, STATUS_TYPE_NAME, FALLBACK_ICON, formatedCurrency,
  DASHBOARD_EMPTY,
  truncateLongString, OFFER_TYPE,
} from '../../../utils';

const getTimelineStatus = (item) => {
  switch (item) {
    case BETA_POST_ENUM.ELIGIBLE:
    case BETA_POST_ENUM.BETA_POST_CREATED:
      return STATUS_TYPE_NAME.ELIGIBLE;
    case BETA_POST_ENUM.BETA_POST_APPROVED:
      return STATUS_TYPE_NAME.BETA_POST_APPROVED;
    case BETA_POST_ENUM.BETA_POST_REQUESTED_ADMIN:
      return STATUS_TYPE_NAME.BETA_POST_CREATED;
    case BETA_POST_ENUM.REJECTED:
      return STATUS_TYPE_NAME.REJECTED;
    case BETA_POST_ENUM.PUBLISHED:
      return STATUS_TYPE_NAME.COMPLETED;
    default:
      break;
  }
  return null;
};

const missedCompletedPostCheck = (data, maxDate) => {
  let returnItem = '';
  const isExpired = getDaysDiff(new Date(), maxDate) < 0 || Object.is(getDaysDiff(new Date(), maxDate), -0);
  data && data.map((item) => {
    const publishedDetail = find(item.timeLine, { status: OFFER_STATUS.PUBLISHED });
    if (publishedDetail || isExpired) {
      returnItem = getDaysDiff(publishedDetail && publishedDetail.createdAt, item.endDate) < 0 || isExpired
        ? (
          <>
            <img
              src={TIME_ICON_RED}
              alt="offer"
            />
            {' '}
            Missed deadline
          </>
        ) : '';
    }
  });
  return returnItem;
};

const getTimelineClass = (status) => {
  switch (status) {
    case BETA_POST_ENUM.BETA_POST_APPROVED:
      return 'accepted';
    case BETA_POST_ENUM.BETA_POST_CREATED:
    case BETA_POST_ENUM.ELIGIBLE:
      return 'create';
    case BETA_POST_ENUM.BETA_POST_REQUESTED_ADMIN:
      return 'approval';
    case BETA_POST_ENUM.REJECTED:
    case BETA_POST_ENUM.NOT_ELIGIBLE:
      return 'rejected';
    default:
      return 'create';
  }
};
const renderMyOffersButtons = (el, openModal) => {
  if (!el.isContractAccepted) {
    return (
      <>
        {' '}
        <Button
          color="acceptRequest"
          element="block"
          onClick={() => openModal(el._id)}
        >
          Gig details and Next steps
        </Button>
        {/* {calculateDateDiff(new Date(), el.offerMinDate) === TIMELINE_CONSTANTS.EXPIRED && <div className="flex-card-error-text expire-text">
          <img
            src={TIME_ICON_RED}
            alt="offer"
          />
          {calculateDateDiff(new Date(), new Date(el.offerMinDate))}
        </div>} */}
      </>
    );
  }
  if (el.isContractAccepted) {
    const isEqual = el.betaPostTimeLine && el.betaPostTimeLine.length > 0 && el.betaPostTimeLine.every((val, i, arr) => val.status === arr[0].status);
    if ((isEqual && el.betaPostTimeLine.length > 0 && el.betaPostTimeLine[0].status === BETA_POST_ENUM.PUBLISHED)
      || getDaysDiff(new Date(), el.offerMaxDate) < 0 || Object.is(getDaysDiff(new Date(), el.offerMaxDate), -0)) {
      return (
        <Button
          color="request"
          element="block"
          className="btn-request-blank"
        >
          <span className="icon icon-tick" />
          {' '}
          Offer Completed
          <div className="flex-card-error-text deadline-text">
            {missedCompletedPostCheck(el.betaPostTimeLine, el.offerMaxDate)}
          </div>
        </Button>
      );
    }
    return (
      <div className="flex-card-timeline">
        {el.betaPostTimeLine && el.betaPostTimeLine.map((item) => (
          <div
            className={`flex-card-timeline-row ${getTimelineClass(item.status)}`}
            key={item._id}
            onClick={(e) => {
              e.stopPropagation();
              openModal(el._id, item._id);
            }}
          >
            <p>
              {moment(item.startDate).format(dateFormats.DATE_WITH_YEAR) === moment(item.endDate).format(dateFormats.DATE_WITH_YEAR)
                ? (
                  moment(item.startDate).format(dateFormats.DATE_WITHOUT_YEAR)
                )
                : (
                  `${moment(item.startDate).format(dateFormats.DATE_WITHOUT_YEAR)}
             - ${moment(item.endDate).format(dateFormats.DATE_WITHOUT_YEAR)}`
                )}
              <div className="flex-card-error-text deadline-text">
                {calculateDateDiff(new Date(), item.endDate, item.status) === 'Expired'
                  ? (
                    <>
                      <img
                        src={TIME_ICON_RED}
                        alt="offer"
                      />
                      {' '}
                      Missed deadline
                    </>
                  )
                  : missedCompletedPostCheck(el.betaPostTimeLine)}
              </div>
            </p>
            {getTimelineStatus(item.status) && item.status === BETA_POST_ENUM.BETA_POST_REQUESTED_ADMIN
              ? (
                <>
                  <span>{getTimelineStatus(item.status)}</span>
                  <small className="d-block pt-3">You will receive an email and in-app notification from BYGMusic with feedback or approval. Thanks!</small>
                </>
              )
              : <span>{getTimelineStatus(item.status)}</span>}
          </div>
        ))}
      </div>
    );
  }
};

const breakpointColumnsObj = {
  default: 2,
  1100: 2,
  700: 2,
  500: 1,
};
function OfferCards(props) {
  const {
    offers, handleInfiniteScroll, currentPage, hasNextData, removeOffer, status, loading,
  } = props;
  const [currentOffers, setCurrentOffers] = useState([]);

  useEffect(() => {
    setCurrentOffers(offers);
  }, [offers]);

  function handleLoadMore() {
    handleInfiniteScroll(currentPage + 1, NUMERIC_VALUE.THREE);
  }

  function checkNotification(notification) {
    let hasNotification = false;
    if (notification && notification.length > 0) {
      hasNotification = !notification[0].isDetailRead;
    }
    return hasNotification;
  }

  /* Render the conditions based buttons of all offers */
  const renderAllOffersButtons = (el) => {
    if (!el.isRequested) {
      return (
        <div className="single-btn-group">
          <Button
            color="primary"
            element="block"
            onClick={() => props.openModal(el._id)}
          >
            Learn More
          </Button>
        </div>
      );
    }
    return (
      <div className="single-btn-group">
        <Button
          color="request"
          element="block"
        >
          <span className="icon icon-tick" />
          {' '}
          Request sent for approval 
        </Button>
        <small className="text-center d-block pt-3">Check your email and notifications on this app for next steps.</small>
      </div>
    );
  };

  const renderOffers = useCallback((data) => data.map((el) => {
    const isEqual = el.betaPostTimeLine && el.betaPostTimeLine.length > 0
      && el.betaPostTimeLine.every((val, i, arr) => val.status === arr[0].status);

    const getDeadlineDays = () => Math.abs(getDaysDiff(new Date(), el.endDeadline));
    return (
      <div
        key={el._id}
        className={`flex-card ${(status === OFFER_TABS.PASSED_OFFERS
          || (status === OFFER_TABS.ALL_OFFERS && getDaysDiff(new Date(), el.offerMinDate) < 0 && !el.isRequested)
          || (isEqual && el.betaPostTimeLine.length > 0
            && el.betaPostTimeLine[0].status === BETA_POST_ENUM.PUBLISHED)
          || (status === OFFER_TABS.MY_OFFERS && getDaysDiff(new Date(), el.offerMinDate) < 0 && !el.isContractAccepted)
          || (status === OFFER_TABS.MY_OFFERS && getDaysDiff(new Date(), el.offerMaxDate) < 0 && el.isContractAccepted)) && 'passed-card'}`}
      >
        {removeOffer && !el.isRequested && (
          <UncontrolledDropdown>
            <DropdownToggle className="flex-card-icon icon-cross" />
            <DropdownMenu right className="dropdown-theme">
              <DropdownItem
                onClick={() => {
                  props.removeOffer(el._id);
                }}
              >
                Not interested
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        )}
        <div
          className="flex-card-inner"
          key={el._id}
          onClick={status === OFFER_TABS.ALL_OFFERS || status === OFFER_TABS.MY_OFFERS
            ? () => props.openModal(el._id) : () => null}
        >
          <div className="flex-card-cover-image">
            <img
              src={el.coverImage}
              alt="Cover"
              onClick={status === OFFER_TABS.ALL_OFFERS || status === OFFER_TABS.MY_OFFERS || status === OFFER_TABS.AFFILIATE_OFFERS
            ? () => props.openModal(el._id) : () => null}
            />
          </div>
          <div
            className="flex-card-cover-body"
            // onClick={status === OFFER_TABS.ALL_OFFERS || status === OFFER_TABS.MY_OFFERS
            //   ? () => props.openModal(el._id) : () => null}
          >
            {
              !el?.isClientLogoHide
                ? (
                  <div
                    className={classnames({
                      'flex-card-image': true,
                      notify: checkNotification(el.notification),
                    })}
                  >
                    <ReactImageFallback
                      src={el.clientLogo}
                      fallbackImage={FALLBACK_ICON}
                      alt="Card"
                    />
                  </div>
                )
                : (
                  <div className="flex-card-image transparent-background border-0" />
                )
            }
            {el.gigType && <span className="gigs-badge">{`${OFFER_TYPE[el.gigType]} gig`}</span>}
            <span className="flex-card-title">{el.clientName}</span>
            <h3 className="flex-card-subtitle">{el.title}</h3>
            <p className="flex-card-text">
              {el.description}
            </p>
            <div className="flex-card-offer-text-row">
              {el.participants?.basePrice > 0 || el.basePrice > 0 ? (
                <p className="flex-card-offer-text">
                  <em>
                    {' '}
                    {!el.isContractAccepted ? 'Offered' : 'Accepted'}
                    {' '}
                    for
                  </em>
                  <span>
                    $
                    {
                      el.participants && el.participants.basePrice !== null
                        && el.participants.basePrice !== NUMERIC_VALUE.ZERO
                        ? formatedCurrency(el.participants.basePrice)
                        : formatedCurrency(el.basePrice)
}
                  </span>
                </p>
              ) : (
                <p className="flex-card-offer-text">
                  {!el.isContractAccepted
                    ? (
                      <>
                        <em
                          data-tip={el.basePriceText}
                          data-place="bottom"
                          data-background-color="#fff"
                          data-text-color="#000"
                        >
                          {truncateLongString(el.basePriceText, NUMERIC_VALUE.MAX_BASE_PRICE_TEXT_LIMIT, false)}
                        </em>
                        <ReactTooltip effect="solid" />
                      </>
                    )
                    : (
                      <em>
                        Gig
                        <br />
                        {' '}
                        Accepted
                      </em>
                    )}
                </p>
                )}
              {el.offerMinDate && (
                <p className="flex-card-offer-text">
                  <em>Gig timeline</em>
                  <span>
                    {moment(el.offerMinDate).format(dateFormats.DATE_WITHOUT_YEAR)}
                    {' - '}
                    {moment(el.offerMaxDate).format(dateFormats.DATE_WITHOUT_YEAR)}
                  </span>
                </p>
              )}
              {!el.isContractAccepted && status !== OFFER_TABS.MY_OFFERS && (
              <p className="flex-card-offer-text">
                {getDeadlineDays() > NUMERIC_VALUE.ZERO
                  && (
                  <>
                    <em>Offer expires in</em>
                    <span>
                      {getDeadlineDays() === 1 ? `${getDeadlineDays()} day` : `${getDeadlineDays()} days`}
                    </span>
                  </>
                  )}
                {
                  getDeadlineDays() === NUMERIC_VALUE.ZERO
                  && <em>Offer expires today</em>
                }

              </p>
              )}
            </div>
            {(status === OFFER_TABS.PASSED_OFFERS)
              && (el.participants && el.participants.rejectReason && (el.participants.rejectReason.preDefined !== null
                || el.participants.rejectReason.custom !== null))
              && (
                <div className="flex-card-error-text">
                  <img
                    src={ERROR_ICON}
                    alt="offer"
                  />

                  { `${el.participants.rejectReason.preDefined} ${el.participants.rejectReason.custom}`}
                </div>
              )}
            {(status === OFFER_TABS.ALL_OFFERS || status === OFFER_TABS.AFFILIATE_OFFERS) && renderAllOffersButtons(el)}
            {(status === OFFER_TABS.MY_OFFERS) && renderMyOffersButtons(el, props.openModal)}
          </div>
        </div>
      </div>
    );
  }));
  return (
    <>
      {currentOffers && currentOffers.length > 0 && (
        <div id="scrollableDiv" className="dashboard-content-card-list ">
          <InfiniteScroll
            dataLength={currentOffers.length}
            next={handleLoadMore}
            hasMore={hasNextData}
          >
            <Masonry
              breakpointCols={breakpointColumnsObj}
              className="dashboard-cards"
              columnClassName="bm-masonry-grid-column"
            >
              {currentOffers && renderOffers(currentOffers)}
            </Masonry>
          </InfiniteScroll>
        </div>
      )}

      {(!loading && (!offers || offers.length < 1)) && (
        <div className="empty_box">
          <div className="empty_box_content">
            <img src={DASHBOARD_EMPTY} alt="Empty dashboard" />
            <p>
              Thanks for checking out our available gigs.
              Please check back soon as new opportunities are added frequently.
              We can’t wait to work together!
            </p>
          </div>
        </div>
      )}
    </>
  );
}
OfferCards.propTypes = {
  offers: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    endDate: PropTypes.string,
    clientName: PropTypes.string,
    startDate: PropTypes.string,
    clientLogo: PropTypes.string,
    coverImage: PropTypes.string,
    basePrice: PropTypes.number,
    count: PropTypes.number,
    status: PropTypes.string,
    offerMinDate: PropTypes.string,
    offerMaxDate: PropTypes.string,
    isRequested: PropTypes.bool,
  })),
  hasNextData: PropTypes.bool,
  handleInfiniteScroll: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  removeOffer: PropTypes.func,
  openModal: PropTypes.func,
  status: PropTypes.string,
  loading: PropTypes.bool,
};
OfferCards.defaultProps = {
  offers: [],
  removeOffer: null,
  hasNextData: true,
  openModal: false,
  status: null,
  loading: false,
};
export default OfferCards;
